const SECONDS_PER_MINUTE = 60;
const SECONDS_PER_HOUR = 60 * SECONDS_PER_MINUTE;

/**
 * A remaining wait, rendered for a button label.
 *
 * Under an hour it stays `m:ss` — the shape a resend timer has always had, and
 * the one people read as "seconds left".
 *
 * At an hour or more it switches to `Xh Ym`, because the SMS resend cooldown
 * escalates to a full day and `m:ss` does not degrade gracefully into that: the
 * minutes just keep counting up, so a 24-hour wait rendered as `1439:40` — a
 * number nobody parses as "tomorrow". Seconds are dropped there on purpose;
 * they are noise on a wait that long, and a field that changes once a minute
 * reads as calmer than one ticking pointlessly for a day.
 */
export const formatCountdown = (totalSeconds: number): string => {
  const seconds = Math.max(0, Math.ceil(totalSeconds));

  if (seconds >= SECONDS_PER_HOUR) {
    const hours = Math.floor(seconds / SECONDS_PER_HOUR);
    const minutes = Math.floor(
      (seconds % SECONDS_PER_HOUR) / SECONDS_PER_MINUTE
    );

    return `${hours}h ${String(minutes).padStart(2, "0")}m`;
  }

  const minutes = Math.floor(seconds / SECONDS_PER_MINUTE);

  return `${minutes}:${String(seconds % SECONDS_PER_MINUTE).padStart(2, "0")}`;
};
